// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiontextController from "./actiontext_controller"
application.register("actiontext", ActiontextController)

import ActiveLinkController from "./active_link_controller"
application.register("active-link", ActiveLinkController)

import AddBaselineModalController from "./add_baseline_modal_controller"
application.register("add-baseline-modal", AddBaselineModalController)

import AddMetricOwnerModalController from "./add_metric_owner_modal_controller"
application.register("add-metric-owner-modal", AddMetricOwnerModalController)

import AddTargetModalController from "./add_target_modal_controller"
application.register("add-target-modal", AddTargetModalController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ClonePlanModalController from "./clone_plan_modal_controller"
application.register("clone-plan-modal", ClonePlanModalController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import ContributorWarningController from "./contributor_warning_controller"
application.register("contributor-warning", ContributorWarningController)

import DateFormatterController from "./date_formatter_controller"
application.register("date-formatter", DateFormatterController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DefaultPageController from "./default_page_controller"
application.register("default-page", DefaultPageController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import ExpandOrCollapseController from "./expand_or_collapse_controller"
application.register("expand-or-collapse", ExpandOrCollapseController)

import ExternalLinkController from "./external_link_controller"
application.register("external-link", ExternalLinkController)

import FileuploadController from "./fileupload_controller"
application.register("fileupload", FileuploadController)

import FolderController from "./folder_controller"
application.register("folder", FolderController)

import GoalProgressUpdateModalController from "./goal_progress_update_modal_controller"
application.register("goal-progress-update-modal", GoalProgressUpdateModalController)

import HelpscoutBeaconController from "./helpscout_beacon_controller"
application.register("helpscout-beacon", HelpscoutBeaconController)

import HelpscoutMessageController from "./helpscout_message_controller"
application.register("helpscout-message", HelpscoutMessageController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import ImageDeleteController from "./image_delete_controller"
application.register("image-delete", ImageDeleteController)

import LazyDropdownController from "./lazy_dropdown_controller"
application.register("lazy-dropdown", LazyDropdownController)

import MeasurementModalController from "./measurement_modal_controller"
application.register("measurement-modal", MeasurementModalController)

import MetaReplacementController from "./meta_replacement_controller"
application.register("meta-replacement", MetaReplacementController)

import MetricUnitSelectorController from "./metric_unit_selector_controller"
application.register("metric-unit-selector", MetricUnitSelectorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import PdfDownloadModalController from "./pdf_download_modal_controller"
application.register("pdf-download-modal", PdfDownloadModalController)

import PdfGeneratorController from "./pdf_generator_controller"
application.register("pdf-generator", PdfGeneratorController)

import PlanShowController from "./plan_show_controller"
application.register("plan-show", PlanShowController)

import PopModalController from "./pop_modal_controller"
application.register("pop-modal", PopModalController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import PresentationController from "./presentation_controller"
application.register("presentation", PresentationController)

import PurchaseOrderFormController from "./purchase_order_form_controller"
application.register("purchase-order-form", PurchaseOrderFormController)

import RememberedDismissedController from "./remembered_dismissed_controller"
application.register("remembered-dismissed", RememberedDismissedController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import RemoteSubmitController from "./remote_submit_controller"
application.register("remote-submit", RemoteSubmitController)

import RemotelyUpdateController from "./remotely_update_controller"
application.register("remotely-update", RemotelyUpdateController)

import RequiredCheckboxGroupController from "./required_checkbox_group_controller"
application.register("required-checkbox-group", RequiredCheckboxGroupController)

import ResizerController from "./resizer_controller"
application.register("resizer", ResizerController)


import ScrollableController from "./scrollable_controller"
application.register("scrollable", ScrollableController)

import SelectUpdaterController from "./select_updater_controller"
application.register("select-updater", SelectUpdaterController)

import SessionActiveController from "./session_active_controller"
application.register("session-active", SessionActiveController)

import ShakeController from "./shake_controller"
application.register("shake", ShakeController)

import ShowAndHideController from "./show_and_hide_controller"
application.register("show-and-hide", ShowAndHideController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SimpleSearchController from "./simple_search_controller"
application.register("simple-search", SimpleSearchController)

import SlCopyValueController from "./sl_copy_value_controller"
application.register("sl-copy-value", SlCopyValueController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SliderToggleController from "./slider_toggle_controller"
application.register("slider-toggle", SliderToggleController)

import SparklineController from "./sparkline_controller"
application.register("sparkline", SparklineController)

import SuggesterController from "./suggester_controller"
application.register("suggester", SuggesterController)

import TimelineController from "./timeline_controller"
application.register("timeline", TimelineController)


import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboRequestController from "./turbo_request_controller"
application.register("turbo-request", TurboRequestController)

import TypedConfirmationModalController from "./typed_confirmation_modal_controller"
application.register("typed-confirmation-modal", TypedConfirmationModalController)

import VerificationModalController from "./verification_modal_controller"
application.register("verification-modal", VerificationModalController)

import YoutubeIframeEmbedController from "./youtube_iframe_embed_controller"
application.register("youtube-iframe-embed", YoutubeIframeEmbedController)

import YoutubeIframeSeekController from "./youtube_iframe_seek_controller"
application.register("youtube-iframe-seek", YoutubeIframeSeekController)
